module.exports = __webpack_public_path__ + "img/wossnewlogo1.d927a5f8.png";